// import { get } from 'lodash';

export function getURLWithLang(url, siteTag, langKey) {
  switch (siteTag) {
    case 'freshlane':
    case 'everplate':
      return `/${langKey}/${url}`.replaceAll(/\/{2,}/g, '/');

    default:
      return url;
  }
}

export function translateTo({ lang, translations, defaultLang }) {
  return (key) => {
    const text =
      translations?.[lang]?.[key] ?? translations?.[defaultLang]?.[key];
    // get(translations, [lang, key]) || get(translations, [defaultLang, key]);

    if (text) return text;

    throw new Error(`Missing translation for ["${lang}", "${key}"]`);
  };
}

// Function to get current url
export const getCurrURL = () => {
  const urlString = window.location.href;
  const url = new URL(urlString);

  return url.href;
};

// Function to get Inbound Lead tag according to the utm_source and utm_medium
export const getLeadTag = (source, medium, curURL) => {
  if (source === 'facebook' && medium === 'social') return 'Inbound: Facebook';

  if (source === 'linkedin' && medium === 'social') return 'Inbound: LinkedIn';

  if (source === 'twitter' && medium === 'social') return 'Inbound: Twitter';

  if (source === 'tiktok' && medium === 'social') return 'Inbound: TikTok';

  if (source === 'adwords' && medium === 'ppc') return 'Inbound: Google Search';

  if (source === 'yahoo' && medium === 'cpc') return 'Inbound: Yahoo Search';

  if (source === 'google' && medium === 'sdc') return 'Inbound: Google Display';

  if (source === 'google' && medium === 'gdn') return 'Inbound: Google Display';

  if (source === 'google' && medium === 'pmax') return 'Inbound: Google';

  if (source === 'google' && medium === 'video') return 'Inbound: Google Video';

  if (medium === 'affiliate') return 'Inbound: Affiliate';

  if (medium === 'unpaid-social') return 'Inbound: Socials';

  if (medium === 'email') return 'Inbound: Email';

  if (source === 'messagebird' && medium === 'sms') return 'Inbound: SMS';

  if (source === 'messagebird' && medium === 'whatsapp')
    return 'Inbound: WhatsApp';

  if (source === 'messagebird' && medium === 'line') return 'Inbound: Line';

  if (source === 'messagebird' && medium === 'kakao') return 'Inbound: Kakao';

  if (medium === 'tradeshow') return 'Inbound: Trade Show';

  if (medium === 'offline') return 'Inbound: Offline';

  if (curURL.includes('/blog/')) return 'Inbound: Blog';

  return 'Inbound: Website';
};
